module.exports = __webpack_public_path__ + "img/foreward_1.d0d9d752.jpg";